import { __makeTemplateObject } from "tslib";
import { LoadingButton } from '../Button';
import styled from 'styled-components';
var ActionLoadingButton = styled(LoadingButton).attrs(function (_a) {
    var color = _a.color;
    return ({
        color: color || 'primary',
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    min-width: auto;\n    padding: 0px 8px;\n  }\n"], ["\n  && {\n    min-width: auto;\n    padding: 0px 8px;\n  }\n"])));
export default ActionLoadingButton;
var templateObject_1;
//# sourceMappingURL=ActionLoadingButton.js.map